/**
 * Genera el path correcto para las grabaciones
 * @param {String} recordingfile - URL de la grabacion
 * @param {Boolean} isMp3 - generar en MP3
 * @returns {String}
 */
export default (recordingfile, isMp3 = false) => {
  if (recordingfile?.length <= 1) return "";

  const recordingFileFixed = `${recordingfile.slice(0, recordingfile.length - 4)}.${isMp3 ? "mp3" : "wav"}`;

  if (recordingFileFixed.includes("/")) return recordingFileFixed;
  const date = recordingFileFixed.split("-")[3];

  if (!date) return "";

  const pathDate = `${date.slice(0, 4)}/${date.slice(4, 6)}/${date.slice(6, 8)}`;

  const path = `/var/spool/asterisk/monitor/${pathDate}/${recordingFileFixed}`;
  return path;
};
